import React, { useEffect, useState } from 'react';
import { deletePopup, getAllPopups } from '../services/popupService';
import { EditIcon } from '../assets/icons';
import CreatePopupModal from '../components/UserModals/CreatePopupModal';
import EditPopupModal from '../components/UserModals/EditPopupModal';
import ActionButton from '../components/common/ActionButton';

const Popups = () => {
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      setIsLoading(true);
      setError(null);
      const data = await getAllPopups();
      setUsers(data);
    } catch (error) {
      console.error('Failed to fetch users:', error);
      setError('Kullanıcı listesi yüklenirken bir hata oluştu.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleEdit = (user) => {
    setSelectedUser(user);
    setEditModalOpen(true);
  };

  const handleDelete = async (user) => {
      setIsLoading(true);
      setError(null);
  
      try {
       var dd= await deletePopup(user.id);
        // Update the user's status in the local state
        if(dd==1){
          setUsers(prevUsers => 
            prevUsers.map(u => 
              u.id === user.id 
                ? { ...u, aktifMi: !u.aktifMi }
                : u
            )
          );
          window.location.reload()
        }else{
          alert("Gruba kayıtlı personelleri silmeden silemezsiniz.")
        }
       
      } catch (error) {
        setError('Kullanıcı durumu güncellenirken bir hata oluştu.');
        console.error('User status update error:', error);
      } finally {
        setIsLoading(false);
      }
  };

  const handleCreateSuccess = (newUser) => {
    setUsers(prevUsers => [...prevUsers, newUser]);
  };

  const handleEditSuccess = (updatedUser) => {
    setUsers(prevUsers => 
      prevUsers.map(user => 
        user.id === updatedUser.id ? updatedUser : user
      )
    );
    fetchUsers();
    setEditModalOpen(false);
  };

  if (isLoading) {
    return (
      <div className="people-container">
        <h1 className="page-title">Kayıtlı Popuplar</h1>
        <div className="loading">Yükleniyor...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="people-container">
        <h1 className="page-title">Kayıtlı Popuplar</h1>
        <div className="error-message">{error}</div>
      </div>
    );
  }
  function pad(num) {
    return num.toString().padStart(2, '0');
  }
  
  /**
   * date: string | Date | anything
   * withTime: eğer true ise "YYYY-MM-DDTHH:MM" (local) döner, değilse sadece "YYYY-MM-DD"
   */
  function formatDateForInput(date, withTime = true) {
    if (!date) return "";
    let d;
    if (typeof date === "string") {
      d = new Date(date);
    } else if (date instanceof Date) {
      d = date;
    } else {
      return "";
    }
    if (isNaN(d)) return "";
  
    // Local tarih/saat almak için getFullYear vs kullanıyoruz (ISO string UTC bazlıdır)
    const year = d.getFullYear();
    const month = pad(d.getMonth() + 1);
    const day = pad(d.getDate());
  
    if (!withTime) {
      return `${year}-${month}-${day}`;
    }
  
    const hours = pad(d.getHours());
    const minutes = pad(d.getMinutes());
  
    return `${year}-${month}-${day}T${hours}:${minutes}`; // datetime-local uyumlu
  }
  
  return (
    <div className="people-container">
      <h1 className="page-title">Kayıtlı Popuplar</h1>
      <div className='add-and-search-container'>
        <ActionButton 
          title="Yeni Popup Ekle"
          onClick={() => setCreateModalOpen(true)}
        />
        {/* <div className='search-container'>
          <input type='text' placeholder='Kişi ismini yazınız.' />
          <select name='order' id='order'>
                <option value='asc'>Artan</option>
                <option value='desc'>Azalan</option>
            </select>
        </div> */}
      </div>
      <div className="table-container">
        <table className="users-table">
          <thead>
            <tr>
              <th>Başlık</th>
              <th>İçerik</th>
              <th>Başlangıç</th>
              <th>Bitiş</th>
              <th>Foto</th>
              <th>Video</th>
             
              <th>İşlemler</th>
            </tr>
          </thead>
          <tbody>
            {users.map((user) => (
              <tr key={user.id}>
                <td>{user.baslik}</td>
                <td>{user.icerik}</td>
                <td>{formatDateForInput(user.baslangicTarihi)}</td>
                <td>{formatDateForInput(user.bitisTarihi)}</td>
                <td>{user.foto  ? (
                <img 
                  src={user.foto} 
                  alt="foto" 
                  style={{ maxWidth: "200px", height: "auto" }} 
                />
              ) : (
                user.foto
              )}</td>
                <td>{user.video ? (
                    <a
                      href={user.video}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Video bağlantısı"
                    >
                      Video
                    </a>
                  ) : (
                    "" // veya <span aria-hidden="true">-</span> gibi görünmesini istersen
                  )}</td>
                
                <td className="actions">
                  <button 
                    className="icon-button edit"
                    onClick={() => handleEdit(user)}
                    title="Düzenle"
                  >
                    Düzenle
                    <EditIcon color='black' />
                  </button>
                  <button 
                    className={`icon-button status ${user.aktifMi ? 'active' : 'passive'}`}
                    onClick={() => handleDelete(user)}
                    title={user.aktifMi ? 'Sil' : 'Sil'}
                  >
                    <div className="status-indicator">
                      {user.aktifMi ? 'Sil' : 'Sil'}
                      <input 
                        type="radio" 
                        checked={user.aktifMi} 
                        readOnly 
                      />
                    </div>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <CreatePopupModal 
        isOpen={createModalOpen}
        onClose={() => setCreateModalOpen(false)}
        onSuccess={handleCreateSuccess}
      />

      {selectedUser && (
        <>
          <EditPopupModal
            isOpen={editModalOpen}
            onClose={() => {
              setEditModalOpen(false);
              setSelectedUser(null);
            }}
            user={selectedUser}
            onSuccess={handleEditSuccess}
          />
        </>
      )}
    </div>
  );
};

export default Popups;
